import React from 'react';
import { FaEdit } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import "./style.sass";

const CreateSection = () => {
    return (
        <section className='hero is-bold has-background-white'>
            <div className='hero-body'>
                <div className='container'>
                    <h1 className='py-4 has-text-centered section'>
                        <p className='title is-size-3 py-2' style={{ letterSpacing: "0.1em" }}>
                            Organize a birthday greeting
                        </p>
                    </h1>

                    <div className="buttons has-addons is-centered pb-5">
                        <Link to="/create/birthday">
                            <button className="has-text-weight-bold button is-rounded is-primary is-large">
                                <FaEdit className="edit-button" /> Create
                            </button>
                        </Link>
                    </div>


                </div>
            </div>
        </section>
    )
}

export default CreateSection;
